export default __webpack_public_path__ + "static/media/gradient_ringer_default.a136a7ec.png";